<template>
    <b-modal
        id="modalantechui"
        ref="modalantechui"
        :lazy="true"
        title-tag="h2"
        centered
        size="xl"
        title="Antech Order Dialog"
        hideHeaderClose
        :hide-footer="true"
        no-close-on-backdrop
    >
        <div slot="modal-header" class="d-flex justify-content-between w-100">
            <h2 class="d-md-block d-none my-2">Antech Order Dialog</h2>
            <span class="align-self-center text-danger">
                If you exit before placing order, you will have 30 days to
                complete the order &nbsp;<button
                    class="btn btn-primary"
                    @click="postOrder"
                >
                    Exit
                </button>
            </span>
        </div>

        <div class="modal-body" style="min-height: 5rem;">
            <div id="pims-immersion-iframe-container">
                <iframe
                    id="pims-immersion-iframe-app"
                    class="pims-immersion-iframe-app"
                    :src="iframeUrl"
                    :height="iframe.style.height"
                    :width="iframe.style.width"
                >
                </iframe>
            </div>
        </div>
    </b-modal>
</template>
<script>
import ScheduleHelper from "@/module/schedule/helper";
import Lab from "@/services/lab";
import DialogMixin from "@/mixins/dialog-queue";
import { isEmpty } from "lodash";

export default {
    mixins: [ScheduleHelper, DialogMixin],
    data() {
        return {
            isLoading: false,
            data: null,
            accessToken: "",
            accessionId: "",
            accessionIds: [],
            labResponse: {},
            redirectUrl: "",
            iframeUrl: "",
            iframe: {
                src: process.env.ANTECH_IMMERSE_URL + "/testGuide?",
                style: {
                    position: "absolute",
                    width: "100%",
                    height: "550px"
                },
                wrapperStyle: {
                    overflow: "hidden"
                }
            },
            orderPlaced: false,
            global_idexx_params: null
        };
    },
    methods: {
        open(params) {
            let self = this;

            self.accessToken = params.antech_token;
            self.accessionIds = params.accession_id;
            self.accessionId = params.accession_id[0];
            self.labResponse = params.lab_response;
            self.redirectUrl = params.url;

            self.iframeUrl = `${self.iframe.src}accessToken=${self.accessToken}&ClinicAccessionID=${self.accessionId}`;

            this.$refs.modalantechui.show();
        },
        redirectToPage(mod, url) {
            switch (mod) {
                case "patient":
                case "soap":
                    window.location.href =
                        process.env.APPS + "index.php/" + url;
                    break;
                case "client_profile":
                case "invoice_dashboard":
                    window.open(
                        process.env.APPS + "index.php/" + url,
                        "_blank"
                    );
                    break;
                default:
                    break;
            }
        },
        async postOrder() {
            Lab.getAntechOrderStatus(this.accessionId)
                .then(response => {
                    if (response && response.code == 200) {
                        if (response.actions && response.actions.length > 0) {
                            response.actions.forEach(item => {
                                if (item.uri) {
                                    window.open(item.uri);
                                }
                            });
                        }

                        this.$root.$emit("antech-status-update");
                        this.$emit("reload");
                    } else {
                        this._message(
                            "Error : Unable to get order status",
                            "danger"
                        );
                    }
                })
                .catch(error => {
                    this._message(
                        "Error : Unable to get order status",
                        "danger"
                    );
                });

            this.$refs.modalantechui.hide();
            this.$root.$emit("dialog-closed");
            this.$root.$emit("antech-ui-closed");

            // if there are more than one accession id, load the next accession id in separate iframe
            this.accessionIds.shift();
            if (this.accessionIds.length > 0) {
                let param = {
                    antech_token: this.accessToken,
                    accession_id: this.accessionIds,
                    lab_response: this.labResponse
                };

                // 1 sec timeout to allow second or next item added into immersedUI iframe correctly
                setTimeout(() => {
                    this.$root.$emit("call-antech-iframe", param);
                }, 1000);
            }

            if (!isEmpty(this.labResponse)) {
                if (this.labResponse.idexx_iframe) {
                    this.$root.$emit("call_idexx_iframe", this.labResponse);
                } else {
                    this.$root.$emit(
                        "call-multirequsition-modal",
                        this.labResponse
                    );
                }
            }
        }
    }
};
</script>
<style>
@media (max-width: 979px) {
    #modalantechui.modal.fade.in {
        top: 0px;
        left: 0px;
    }
}

@media (min-width: 992px) {
    .modal-xl {
        max-width: 990px !important;
    }
}

@media (min-width: 1200px) {
    .modal-xl {
        max-width: 1140px !important;
    }
}

@media (min-width: 1300px) {
    .modal-xl {
        max-width: 1250px !important;
    }
}

#modalantechui .modal-body {
    background-color: white;
    padding: 0px;
}

#modalantechui {
    overflow-x: auto;
}

#pims-immersion-iframe-container {
    position: relative;
}
</style>
